import { createTheme } from '@mui/material/styles';
import { getCostPanelTheme } from './storePanelTheme';

/** MUI theme for superadmin / project-admin shell (dark + light). */
export function createAdminPanelMuiTheme(mode = 'dark') {
  const ui = getCostPanelTheme('admin', mode);
  const isLight = mode === 'light';

  return createTheme({
    palette: {
      mode: isLight ? 'light' : 'dark',
      primary: { main: isLight ? '#1e40af' : '#2196f3' },
      background: {
        default: ui.pageBg,
        paper: ui.cardBg,
      },
      text: {
        primary: ui.textPrimary,
        secondary: ui.textSecondary,
      },
      divider: isLight ? '#cbd5e1' : '#2f3a46',
    },
    components: {
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundImage: 'none',
          },
        },
      },
      MuiTab: {
        styleOverrides: {
          root: {
            color: ui.textSecondary,
            '&.Mui-selected': { color: ui.textPrimary },
          },
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          root: { color: ui.textSecondary },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            color: ui.textPrimary,
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: isLight ? '#94a3b8' : '#546e7a',
            },
          },
        },
      },
      MuiSelect: {
        styleOverrides: {
          icon: { color: ui.textSecondary },
        },
      },
      MuiAccordionSummary: {
        styleOverrides: {
          root: { color: ui.textPrimary },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          root: {
            color: ui.textPrimary,
            borderColor: isLight ? '#e2e8f0' : '#2f3a46',
          },
          head: {
            color: ui.textPrimary,
            fontWeight: 600,
          },
        },
      },
      MuiTableSortLabel: {
        styleOverrides: {
          root: {
            color: ui.textSecondary,
            '&.Mui-active': { color: ui.textPrimary },
            '& .MuiTableSortLabel-icon': { color: `${ui.textSecondary} !important` },
          },
        },
      },
      MuiDialog: {
        styleOverrides: {
          paper: {
            backgroundColor: ui.cardBg,
            color: ui.textPrimary,
            backgroundImage: 'none',
          },
        },
      },
      MuiDrawer: {
        styleOverrides: {
          paper: {
            backgroundColor: ui.cardBg,
            color: ui.textPrimary,
            backgroundImage: 'none',
          },
        },
      },
      MuiFormHelperText: {
        styleOverrides: {
          root: { color: ui.textSecondary },
        },
      },
      MuiTypography: {
        styleOverrides: {
          root: { color: 'inherit' },
        },
      },
    },
  });
}

/** MUI theme for module store page. */
export function createStorePageMuiTheme(mode = 'dark') {
  const ui = getCostPanelTheme('store', mode);
  const isLight = mode === 'light';

  return createTheme({
    palette: {
      mode: isLight ? 'light' : 'dark',
      primary: { main: isLight ? '#1e40af' : '#2196f3' },
      background: {
        default: ui.pageBg,
        paper: ui.cardBg,
      },
      text: {
        primary: ui.textPrimary,
        secondary: ui.textSecondary,
      },
      divider: isLight ? '#cbd5e1' : '#2f3a46',
    },
    components: {
      MuiPaper: {
        styleOverrides: {
          root: { backgroundImage: 'none' },
        },
      },
      MuiAppBar: {
        styleOverrides: {
          root: {
            backgroundImage: 'none',
          },
        },
      },
    },
  });
}
